import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MUNICIPALITY_PAYMENT_SCHEDULES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.CREATE_MUNICIPALITY_PAYMENT_SCHEDULE_BULK:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_MUNICIPALITY_PAYMENT_SCHEDULE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_MUNICIPALITY_PAYMENT_SCHEDULE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_MUNICIPALITY_PAYMENT_SCHEDULE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_MUNICIPALITY_PAYMENT_SCHEDULE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
